import { useState, useEffect } from "react";
import IconCard from "../../common/IconCard/IconCard";
import CLINIC_CONFIG from '../../../config/clinicConfig';
import CardHeader from "../../common/CardHeader/CardHeader";

const ConvenientPart = () => {
  const [lottieData, setLottieData] = useState<{
    locationPin: object | null;
    booking: object | null;
    emergency: object | null;
    calendar: object | null;
  }>({
    locationPin: null,
    booking: null,
    emergency: null,
    calendar: null,
  });

  useEffect(() => {
    // Load Lottie JSON files from public folder
    const loadLottieFiles = async () => {
      try {
        const [locationPin, booking, emergency, calendar] = await Promise.all([
          fetch('/homepagelottiejson/Location Pin.json').then(res => res.json()),
          fetch('/homepagelottiejson/booking.json').then(res => res.json()),
          fetch('/homepagelottiejson/247 Emergency.json').then(res => res.json()),
          fetch('/homepagelottiejson/Calendar and clock.json').then(res => res.json()),
        ]);
        setLottieData({ locationPin, booking, emergency, calendar });
      } catch (error) {
        console.error('Error loading Lottie files:', error);
      }
    };
    loadLottieFiles();
  }, []);

  const cards = [
    {
      lottieData: lottieData.locationPin,
      cardClassName: "location-card",
      heading: (
        <a
          href={CLINIC_CONFIG.mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            display: 'inline-block',
          }}
        >
          Convenient Location
        </a>
      ),
      children: (
        <div className="mt-3">
          <iframe
            src={CLINIC_CONFIG.iframe}
            title={CLINIC_CONFIG.iframeTitle}
            width="100%"
            height="150"
            style={{ border: 0, borderRadius: '12px' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      ),
    },
    {
      lottieData: lottieData.booking,
      heading: "Same-Day Treatment",
      link: "/patient-portal",
      children: (
        <p className="mb-0">
          Same-Day Treatment saving you <br />
          from multiple trips to the office! <br />
          <span className="fw-bold">Schedule Now!</span>
        </p>
      ),
    },
    {
      lottieData: lottieData.emergency,
      heading: "Emergency Walk-Ins",
      link: "/patient-portal",
      children: (
        <p className="mb-0">
          Don't let dental pain disrupt <br /> your life.{" "}
          <span className="fw-bold">Call Now!</span>
        </p>
      ),
    },
    {
      lottieData: lottieData.calendar,
      heading: "Flexible Appointment",
      link: "/patient-portal",
      children: (
        <p className="mb-0">
          <span className="fw-bold">Contact Us</span> to fit your schedule.
        </p>
      ),
    },
  ];

  return (
    <section className="container my-5 home-glass-section">
      <div>
        <CardHeader>CONVENIENT</CardHeader>
      </div>

      <div>
        <div className="row g-4 justify-content-center">
          {cards.map((card, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-3">
              <IconCard {...card} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConvenientPart;
